import datePicker from 'vue-bootstrap-datetimepicker';

Vue.component('create-campaign', {
	template: `
        <tbody>
            <tr v-if="createForm.alert !== null">
                <td colspan="5">
                    <alert :type="createForm.alert.type" :message="createForm.alert.message" :errors="createForm.alert.errors"></alert>
                </td>
            </tr>

            <tr>
                <td>
                    <select class="form-control" v-model="createForm.data.type" required="">
                        <option></option>
                        <option value="email">Email</option>
                        <option value="sms">SMS</option>
                    </select>
                </td>

                <td>
                    <select class="form-control" v-model="createForm.data.template" required="">
                        <option></option>
                        <option v-for="template in filteredTemplates" :value="template.id">
                            {{template.title}}
                        </option>
                    </select>
                </td>

                <td>
                    <select class="form-control" v-model="createForm.data.from" required="">
                        <option></option>
                        <option v-for="email in config.emails" :value="email.id">
                            {{email.first_name}} {{email.last_name}} - {{email.email}}
                        </option>
                    </select>
                </td>

                <td>
                    <date-picker 
                        v-model="createForm.data.scheduled_at"
                        :config="tpOptions"
                        required=""
                    ></date-picker>
                </td>

                <td>
                    <button 
                        @click="createCampaign"
                        class="btn btn-primary btn-block"
                        :disabled="createForm.data.working"
                    >
                        <i class="fa fa-spin fa-spinner" v-if="createForm.data.working"></i>
                        <i class="fa fa-save"></i>
                    </button>
                </td>
            </tr>
        </tbody>
	`,

	props: [
		'config'
	],

	components: {
        datePicker
    },

	data () {
		return {
            tpOptions: {
                format: 'DD/MM/YYYY HH:mm',
            },

			createForm: $.extend(true, new Form({
                data: {
                    type: '',
                    template: '',
                    from: '',
                    scheduled_at: null,
                },

                working: false,
            }), {}),

            filtered_templates: []
		}
	},

	methods: {
		createCampaign () {
			this.createForm.working = true;

			this.createForm.data.client = this.config.id;

            Http.post('/api/campaign/create', this.createForm, {}).then((response) => {
                this.$emit('on-fetch-campaigns');

                this.createForm.working = false;

                this.createForm.resetForm();
            });
		},
	},

    computed: {
        filteredTemplates () {
            if (!this.createForm.data.type) {
                return [];
            }

            return this.config.templates.filter(t => t.communication_type == this.createForm.data.type);
        }
    }
})